// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FXQ4","colBig":"styles_colBig__3-1_t","colSmall":"styles_colSmall__3fbk8"};